import neatCsv from '../utilities/neat-csv/neat-csv';
import _ from 'lodash';
import * as Validation from './validation/featureImporter';

class FeatureImporterUtility {
    validation = {
        complete: false,
        errors: {},
        warnings: {}
    }
    data = null;
    getValidation = () => this.validation;
    getData = () => this.data;

    setCSVString = (csvString) => new Promise((resolve) => {
        (async () => {
            this.data = await neatCsv(csvString);
            if (this.data) {
                this.data = this.data.map(feature => {
                    Object.keys(feature).forEach(key => {
                        if (key.includes("filter:") || key.includes("Filter:")) {
                            if (!feature["CustomFilterValues"]) {
                                feature["CustomFilterValues"] = {};
                            }
                            feature["CustomFilterValues"][key.replace("filter:", "")] = feature[key];
                            delete feature[key];
                        }
                    });
                    return feature;
                });
            }
            resolve(this.data);
        })();
    });

    validateData = () => new Promise((resolve) => {
        if (this.data) {
            for (let idx = 0; idx < this.data.length; idx++) {
                var response = Validation.ValidateRow(this.data[idx]);
                if (response.errors && response.errors.length > 0)
                    this.validation.errors[idx] = response.errors;
                if (response.warnings && response.warnings.length > 0)
                    this.validation.warnings[idx] = response.warnings;
            }
            this.validation.complete = true;
        }
        resolve(this.validation);
    });
}

export default FeatureImporterUtility;
export { FeatureImporterUtility };